function dateToString(date: Date | undefined) {
  if (!date) {
    return '(date not found)'
  }
  date = new Date(date)
  return `${
    [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ][date?.getMonth()]
  } ${date?.getUTCDate()}, ${date?.getFullYear()}`
}

export default dateToString
